import { render, staticRenderFns } from "./uloadBtn.vue?vue&type=template&id=7d877e8e"
import script from "./uloadBtn.vue?vue&type=script&lang=js"
export * from "./uloadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports